import {Box, Button, Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const NotificationConfig = () => {
    const {mode} = useDarkMode();
    const nav = useNavigate()

    return <Box sx={{backgroundColor: mode.settings.cardBackgroundColor , borderRadius:1, padding:'20px'}}>
        <Typography variant={'subtitle7'} sx={{color : mode.settings.textColor3 }} mb={3}>Paramètres de notification</Typography>
        <Stack gap={1} >
            <Typography variant="body1" sx={{color : mode.settings.textColor3 }}>
                Gérer vos notifications en fonction de vos besoins
            </Typography>
            <Button className="btn" onClick={() => nav('/configurations/notification') } sx={{alignSelf: "end"}} >
                <img src={'/assets/icon/edit-.png'} style={{marginRight:'10px'}}/>
                <Typography variant={"subtitle3"} component="span">Mettre à jour</Typography>
            </Button>
        </Stack>
    </Box>
}

export default NotificationConfig
